import { render, staticRenderFns } from "./blame_info.vue?vue&type=template&id=4dbd4d5b&scoped=true"
import script from "./blame_info.vue?vue&type=script&lang=js"
export * from "./blame_info.vue?vue&type=script&lang=js"
import style0 from "./blame_info.vue?vue&type=style&index=0&id=4dbd4d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd4d5b",
  null
  
)

export default component.exports